export const apiLoyaltyTransation = {}
